"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Updaters = void 0;
const react_1 = __importDefault(require("react"));
const updater_1 = __importDefault(require("./transactions/updater"));
const updater_2 = __importDefault(require("./application/updater"));
const updater_3 = __importDefault(require("./multicall/updater"));
const Updaters = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(updater_2.default, null),
    react_1.default.createElement(updater_3.default, null),
    react_1.default.createElement(updater_1.default, null)));
exports.Updaters = Updaters;
